import React from 'react';
import { isMobile } from 'react-device-detect';
import { ThemeProvider } from 'styled-components';
import theme from 'theme/theme';

const ThemeProviderExtended: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={{ ...theme, isMobile }}>{children}</ThemeProvider>
);

export default ThemeProviderExtended;
